'use client';

import type { ToolExecutionHar } from '@terra/shared-contracts-tracker';
import type { StoredHarDisplayEntry } from '@terra/shared-utils';
import { Box } from '@terra/ui-styled-system';
import { Spinner } from '../../components/spinner';
import { HarEntryRequestResponseEditors } from '../har/HarEntryRequestResponseEditors';
import { useEnrichedToolHarEntry } from '../har/useEnrichedToolHarEntry';

type ToolExecutionHarRequestResponseEditorsProps = {
  har: ToolExecutionHar;
  viewResetKey?: string;
  height?: string;
};

export function ToolExecutionHarRequestResponseEditors({
  har,
  viewResetKey,
  height,
}: ToolExecutionHarRequestResponseEditorsProps) {
  const { harEntry, isResolving } = useEnrichedToolHarEntry({ har });

  if (isResolving) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" h="full">
        <Spinner size="sm" />
      </Box>
    );
  }

  return (
    <HarEntryRequestResponseEditors
      harEntry={harEntry as StoredHarDisplayEntry}
      viewResetKey={viewResetKey ?? har.id}
      height={height}
      canonicalRequestUrl={har.harEntry.request.url}
    />
  );
}
